import styled from '@emotion/styled';

import { blockingColors, blockingMetrics, blockingTypography } from '../tokens';

export const Overlay = styled('div')`
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
`;

export const Panel = styled('div', {
  shouldForwardProp: (prop) => prop !== '$width',
})<{ $width: number }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: min(100%, ${({ $width }) => $width}px);
  min-height: 214px;
  max-height: calc(100vh - 48px);
  padding: 24px;
  overflow: auto;
  background: ${blockingColors.white};
  border-radius: ${blockingMetrics.radius};
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const Title = styled('h2')`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.modalTitle.size};
  font-weight: ${blockingTypography.modalTitle.weight};
  line-height: ${blockingTypography.modalTitle.lineHeight};
  color: ${blockingColors.textTitle};
`;

export const CloseButton = styled('button')`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: none;
  color: ${blockingColors.textStrong};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Body = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

export const CloseAction = styled('button')`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${blockingMetrics.actionWidth};
  min-width: 98px;
  max-width: ${blockingMetrics.actionMaxWidth};
  height: ${blockingMetrics.actionHeight};
  padding: 12px 16px;
  border: 1px solid ${blockingColors.actionBlue};
  border-radius: ${blockingMetrics.radiusPill};
  background: transparent;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.actionLabel.size};
  font-weight: ${blockingTypography.actionLabel.weight};
  line-height: ${blockingTypography.actionLabel.lineHeight};
  color: ${blockingColors.actionBlue};
  cursor: pointer;

  @media (max-width: ${blockingMetrics.mobileBreakpoint}) {
    width: 100%;
  }
`;
